<div class="content">
  <div class="page-title">
    <h1>ROTE Reports</h1>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.companyId" [disable]="disableCompany" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.locationId" [userLocationIds]="user.locationIds" [disable]="disableLocation" [companyId]="filter.companyId" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>Category</label>
            <app-report-type-picker [id]="filter.categoryId" [_placeholder]="'All'" (onSet)="onCategoryChange($event)"></app-report-type-picker>

          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Engineer</label>
            <app-technician-picker [technicianId]="filter.tabletUser_Id" [_placeholder]="'All'" (onTechnicianSet)="onTechnicanChange($event)"></app-technician-picker>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>Date Range</label>
            <select class="form-control" name="daterange" [(ngModel)]="filter.date_Range" (change)="dateChange($event.target.value)">
              <option value="-1">Predefined Date Range</option>
              <option value="0">1 week</option>
              <option value="1">1 month</option>
              <option value="2">2 months</option>
              <option value="3">3 months</option>
              <option value="6">6 months</option>
              <option value="12">12 months</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>Start Date</label>
            <p-calendar name="start_Date"
                        firstDayOfWeek="1"
                        [style]="{'width':'100%', 'border-color':'#ccc', 'height': 'calc(1.5em + .75rem + 2px)'}"
                        [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                        [(ngModel)]="filter.start_Date" dateFormat="dd/mm/yy"></p-calendar>

          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="form-group">
            <label>End Date</label>
            <p-calendar name="end_Date"
                        firstDayOfWeek="1"
                        [style]="{'width':'100%', 'border-color':'#ccc','height': 'calc(1.5em + .75rem + 2px)'}"
                        [inputStyle]="{'width':'100%', 'border-color':'#ccc', 'padding':'5px 10px','height': 'calc(1.5em + .75rem + 2px)'}"
                        [(ngModel)]="filter.end_Date" dateFormat="dd/mm/yy"></p-calendar>

          </div>
        </div>

      </div>
      <div class="row buffer-bottom">

        <div class="col-md-3 col-sm-6">
          <label>Serial #</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.serial_Num" />
        </div>
        <div class="col-md-3 col-sm-6">
          <label>Job #</label>
          <input type="text" class="form-control" name="acc" [(ngModel)]="filter.job_No" />
        </div>

      </div>

      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>


  <!--<div class="row buffer-bottom" style="margin-left: 40px;">
    <app-basket (click)="refreshRows()"></app-basket>
  </div>

  <div class="row buffer-bottom" style="margin-left: 20px;">
    <i (click)="addAllToBasket()" class="fa fa-plus" style="margin-left: 20px; cursor: pointer;"></i>
  </div>-->


  <app-loading-icon *ngIf="loading"></app-loading-icon>


  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">

    <!--<ngx-datatable-column name="Basket">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <i *ngIf="row.added == undefined || row.added == false" (click)="addToBasket(row)" class="fa fa-plus" style="margin-left:10px; margin-right: 10px; cursor: pointer;"></i>
        <i *ngIf="row.added != undefined && row.added == true" (click)="removeFromBasket(row)" class="fa fa-minus" style="margin-left:10px; margin-right: 10px; cursor: pointer;"></i>
      </ng-template>
    </ngx-datatable-column>-->

    <ngx-datatable-column name="Download">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a href="javascript:void(0)" (click)="downloadReport(row.id, row.plant_Number)">Download</a>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Company" prop="company_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Serial #" prop="serial_Number">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Plant #" prop="plant_Number">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="inspection_Status">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    
    <ngx-datatable-column name="Job Number" prop="job_Num">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    
    <ngx-datatable-column name="Engineer" prop="engineer">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column name="Inspected Date" prop="inspected_At">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value | date: 'dd/MM/yyyy' }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Next Inspection Date" prop="next_Inspected_Date">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value | date: 'dd/MM/yyyy' }}</div>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
